import React from 'react'
import { useLayoutEffect } from 'react'
import Artist from './components/Artist'
import './css/Management.css'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/all'

export default function Management() {
    function randomInteger(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min
    }

    useLayoutEffect(() => {
        const images = gsap.utils.toArray('.artist-card')

        images.forEach((image) => {
            gsap.to(image, {
                opacity: 1,
                y: -randomInteger(50, 70),
                scrollTrigger: {
                    trigger: image,
                    start: `top ${randomInteger(60, 80)}%`,
                    end: 'bottom 10%',
                    scrub: 1 + randomInteger(0, 4),
                    // toggleActions: 'play none none reverse',
                    markers: false,
                },
            })
        })
    }, [])

    return (
        // TODO: connect default links remove youtube
        <div className="management-row">
            <Artist
                img="/images/NinaChuba.webp"
                alt="nina"
                name="Nina Chuba"
                mail="mailto:anna@mag-musik.de"
                spotify="https://open.spotify.com/artist/2kS9NyuATpYwjeB93h24H5?si=N68fcPv6TpSO7ebK6nQzkQ"
                soundcloud="https://soundcloud.com/ninachuba"
                instagram="https://www.instagram.com/ninachuba/"
                tiktok="https://www.tiktok.com/@ninachuba"
                //facebook="https://www.facebook.com/chinanuba"
            />
            <Artist
                img="/images/paulwetz.webp"
                alt="paul"
                name="PaulWetz"
                mail="mailto:moritz@mag-musik.de"
                spotify="https://open.spotify.com/artist/1uaDw0T6O916Kv8TxJsQzb?si=fu_chv0kQ6-SwiGv1_rhHQ"
                soundcloud="https://soundcloud.com/Paulwetz"
                instagram="https://www.instagram.com/paulwetz/"
                tiktok="https://www.tiktok.com/@paulwetz"
                //facebook="https://www.facebook.com/PaulWetz/"
                right
            />
            <Artist
                img="/images/EstherGraf.webp"
                alt="EstherGraf"
                name="Esther Graf"
                mail="mailto:moritz@mag-musik.de"
                instagram="https://www.instagram.com/esthergraf/"
                spotify="https://open.spotify.com/intl-de/artist/1FXdfOOisB3d3hfZOjhjID"
                soundcloud="https://soundcloud.com/esthergraf-music"
                tiktok="https://www.tiktok.com/@itsesthergraf?lang=de-DE"
            />
            <Artist
                img="/images/Dillistone.jpeg"
                alt="dilliStone"
                name={<>Dillistone<br />Morten Aamodt</>}
                nameDescription="Atrist, Songwriter & Producer"
                mail="mailto:moritz@mag-musik.de"
                spotify="https://open.spotify.com/artist/7ypPN35cJ9wfF2Zs7aYS33?si=VurrPTEaTQW2m-bYgYmOLw"
                soundcloud="https://soundcloud.com/dillistone"
                instagram="https://www.instagram.com/dillistoned/"
                //facebook="https://www.facebook.com/DillistoneMusic"
                right
            />
            <Artist
                img="/images/KAYLA SHYX7.webp"
                alt="KaylaShyx"
                name="Kayla Shyx"
                mail="mailto:moritz@mag-musik.de"
                instagram="https://www.instagram.com/kayla_shyx/"
                spotify="https://open.spotify.com/intl-de/artist/37NnQM5PCvTKYI1MIWiNx8"
                soundcloud="https://soundcloud.com/kaylashyx"
                tiktok="https://www.tiktok.com/@kaylashy?lang=de-DE"
            />
            <Artist
                img="/images/momme.webp"
                alt="momme"
                name="Momme Hitzemann"
                nameDescription="Songwriter, Producer & Podcaster"
                mail="mailto:moritz@mag-musik.de"
                spotify="https://open.spotify.com/playlist/0rk2o8KtAC03ZDnMrE7eLv?si=3pu6aUNsQeOcXPJyx5NP2A"
                instagram="https://www.instagram.com/hitzemannn/"
                tiktok="https://www.tiktok.com/@mommelmann/"
                right
            />
            {/* <Artist
                img="/images/Luzine.jpeg"
                alt="Luzine"
                name="Luzine"
                mail="mailto:moritz@mag-musik.de"
                instagram="https://www.instagram.com/luzineeee/"
                tiktok="https://www.tiktok.com/@luzineeeeeeeeee"
                right
            /> */}
            <Artist
                img="/images/CaroSchaeffler.webp"
                alt="CaroSchaeffler"
                name="Caro Schaeffler"
                mail="mailto:moritz@mag-musik.de"
                instagram="https://www.instagram.com/caroschaeffler/"
                spotify="https://open.spotify.com/intl-de/artist/0HOgHNCucycZ7DUyWjFhNB"
                tiktok="https://www.tiktok.com/@caroisbored?lang=de-DE"
            />
            <Artist
                img="/images/NikoAvgerinos.jpeg"
                alt="NikoAvgerinos"
                name="Niko Avgerinos"
                nameDescription="Songwriter & Producer"
                mail="mailto:moritz@mag-musik.de"
                instagram="https://www.instagram.com/nikoavgerinos/"
                spotify="https://open.spotify.com/playlist/7lGWcYDHvZ05yPnU7wUDaO?si=c8a6ff3f7fb449fc"
                right
            />
            <Artist
                img="/images/DLLD.webp"
                alt="dieleuteliebendas"
                name="Die Leute Lieben Das"
                nameDescription="Podcast"
                mail="mailto:moritz@mag-musik.de"
                instagram="https://www.instagram.com/dieleuteliebendas/"
                spotify="https://open.spotify.com/show/7mUxxhlTPzlMoBUgYE4xo9?si=ecee4585ff434d7f"
                tiktok="https://www.tiktok.com/@dieleuteliebendas"
            />
        </div>
    )
}
